import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const ITEM_HEIGHT = 30;

export default function TableFilterMenu({
  options,
  selectedOption,
  setSelectedOption,
  menuName,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const isAllSelected =
    options.length > 0 &&
    options.every((opt) => selectedOption[menuName]?.includes(opt));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedOption((prev) => ({
        ...prev,
        [menuName]: [],
        filteringColumnName: menuName,
      }));
    } else {
      setSelectedOption((prev) => ({
        ...prev,
        [menuName]: options,
        filteringColumnName: menuName,
      }));
    }
  };

  const handleSelectOption = (option) => {
    setSelectedOption((prev) => {
      const currentSelection = prev[menuName] || [];
      const newSelection = currentSelection.includes(option)
        ? currentSelection.filter((item) => item !== option)
        : [...currentSelection, option];

      return {
        ...prev,
        [menuName]: newSelection,
        filteringColumnName: menuName,
      };
    });
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon style={{ color: "white" }} />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "196px",
            },
          },
        }}
      >
        <MenuItem
          onClick={handleSelectAll}
          style={{ fontSize: "14px", padding: "3px" }}
        >
          <Checkbox checked={isAllSelected} />
          Select All
        </MenuItem>
        {options.map((option) => (
          <MenuItem
            key={option}
            onClick={() => handleSelectOption(option)}
            style={{ fontSize: "14px", padding: "3px" }}
          >
            <Checkbox
              checked={selectedOption[menuName]?.includes(option) || false}
            />
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
